export default __webpack_public_path__ + "static/media/waiter.c15b03e2.svg";